module.exports = __webpack_public_path__ + "static/img/match-title.3c85d62.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match-title.png
// module id = l3Hw
// module chunks = 1